import { faCreditCard, faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@/components/atoms';

interface DivisionItemProps {
	divisionName: string;
	isRegistrationOpen: boolean;
	skill?: string;
	age?: string;
	totalSpots: number;
	remainingSpots: number;
	paymentRange: string;
	description: string;
}

export const DivisionItem = ({
	divisionName,
	isRegistrationOpen,
	skill,
	age,
	totalSpots,
	remainingSpots,
	paymentRange,
	description
}: DivisionItemProps) => {
	return (
		<div className="rounded-lg md:p-4">
			<h3 className="text-base">{divisionName}</h3>
			{skill || age ? (
				<p className="text-sm text-gray-600">
					{skill && `Skill: ${skill}`}
					{skill && age && ' | '}
					{age && `Age ${age}+`}
				</p>
			) : null}
			<div className="mt-2">
				<Badge type={isRegistrationOpen ? 'green' : 'gray'} text={isRegistrationOpen ? 'Registration open' : 'Registration closed'} />
			</div>
			<div className="mt-4 text-sm">
				<div className="mb-2 flex items-center">
					<FontAwesomeIcon icon={faUserPlus} className="mr-2 " />
					{totalSpots} spots
					{remainingSpots > 0 && ` (${remainingSpots} remaining)`}
				</div>
				<div className="flex items-center">
					<FontAwesomeIcon icon={faCreditCard} className="mr-2 " />
					{paymentRange}/player
				</div>
			</div>
			<p className="mt-4 text-sm">{description}</p>
		</div>
	);
};

export const TestiDivisionItems = () => {
	return (
		<div className="flex flex-col gap-4 px-4">
			<div className="text-2xl font-bold text-brand-600">Divisions</div>
			<hr />
			<DivisionItem
				divisionName="Division 1"
				isRegistrationOpen={true}
				totalSpots={25}
				remainingSpots={1}
				paymentRange="$40.00 - $70.00"
				description="Free form description of the Division"
			/>
			<hr />
			<DivisionItem
				divisionName="Division 2"
				isRegistrationOpen={true}
				skill="3.5"
				age="50"
				totalSpots={25}
				remainingSpots={1}
				paymentRange="$40.00 - $70.00"
				description="Free form description of the Division - players are only allowed to play in their exact skill & age level."
			/>
			<hr />
			<DivisionItem
				divisionName="Division 3"
				isRegistrationOpen={false}
				totalSpots={25}
				remainingSpots={0}
				paymentRange="$40.00 - $70.00"
				description="Free form description of the Division"
			/>
		</div>
	);
};
